// src/Dashboard/pages/user/Absences/components/AbsencesInfoCard.jsx

import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { INFO_TEXT } from "../utils/absencesUtils";

export default function AbsencesInfoCard() {
  return (
    <div className="overflow-hidden rounded-[24px] border border-blue-200 bg-blue-50 shadow-sm dark:border-blue-500/20 dark:bg-blue-500/10">
      <div className="flex items-start gap-3 p-4 sm:p-5">
        <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white text-blue-700 shadow-sm ring-1 ring-blue-200 dark:bg-slate-900 dark:text-blue-300 dark:ring-blue-500/20">
          <FaInfoCircle />
        </div>

        <div>
          <h2 className="text-sm font-bold text-slate-900 dark:text-white">
            Information importante
          </h2>

          <p className="mt-1 text-sm leading-6 text-slate-700 dark:text-slate-200">
            {INFO_TEXT}
          </p>
        </div>
      </div>
    </div>
  );
}